import { useQuery } from "@tanstack/react-query";
import { getStories, NocoBaseStory } from "@/http/storiesApi";
import { StoryGroup } from "@/@types/stories.types";

export const getStoriesQueryKey = (branchId?: string) => ["stories", branchId];

function transformStoriesToGroups(stories: NocoBaseStory[]): StoryGroup[] {
  const groupsMap = new Map<number, StoryGroup>();

  for (const story of stories) {
    if (!story.story_group) continue;

    const groupId = story.story_group.id;

    if (!groupsMap.has(groupId)) {
      groupsMap.set(groupId, {
        id: String(groupId),
        name: story.story_group.name || "",
        avatarUrl: story.story_group.avatar?.[0]?.url || "",
        stories: [],
      });
    }

    const group = groupsMap.get(groupId)!;
    group.stories.push({
      id: String(story.id),
      imageUrl: story.media?.[0]?.url || "",
      title: story.title || undefined,
      description: story.description || undefined,
      link: story.link || undefined,
      linkText: story.link_text || undefined,
      duration: (story.duration || 5) * 1000, // API returns seconds, convert to ms
    });
  }

  return Array.from(groupsMap.values());
}

interface UseGetStoriesQueryOptions {
  branchId?: string;
}

export function useGetStoriesQuery({ branchId }: UseGetStoriesQueryOptions = {}) {
  return useQuery({
    queryKey: getStoriesQueryKey(branchId),
    queryFn: () => getStories(branchId),
    select: transformStoriesToGroups,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!branchId, // Don't fetch until branchId is available
  });
}
